"use strict";

export const setTimeoutWithCallBack = (cb, delay = 0) => {
  const timeout = setTimeout(() => void cb(), delay);
  return () => clearTimeout(timeout);
};